// 服务基本路径
let config = {
  BASE_URL: 'localhost:8080', // 本地开发
  BASE_PATH: '/', // php 环境 本地
  API_URL: '',
  // API_URL: 'https://member.haomaiyun.net/',
  // API_URL: 'https://7y1gxlk4g1oz6nj8.member.haomaiyun.com',
  // TEST_API_URL: 'https://7y1gxlk4g1oz6nj8.member.haomaiyun.com', // 测试代理地址
  TEST_API_URL: 'https://12nm73lzy5oyg9ev.member.haomaiyun.net', // 测试代理地址
  API_URL_MARKET: 'https://market.haomaiyun.com',
  WXAPP_ID: '',
  COMPONENT_APPID: '', // member测试,
  ALIPAY_ID: '' // 测试
}
module.exports = config



// WEBPACK FOOTER //
// ./src/config/index.js